import { useEffect, useState } from "react";

/** Local 1s tick counting down to an ISO timestamp. No polling involved — see `next_transition_at`. */
export function useCountdown(targetIso: string | null): string | null {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    if (!targetIso) {
      setLabel(null);
      return;
    }
    const targetMs = Date.parse(targetIso);

    const tick = () => {
      const remainingMs = targetMs - Date.now();
      setLabel(remainingMs <= 0 ? "shortly" : formatDuration(remainingMs));
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  return label;
}

function formatDuration(ms: number): string {
  const totalMinutes = Math.ceil(ms / 60_000);
  if (totalMinutes < 60) return `${totalMinutes}m`;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}
